import type { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import BottomSheetKeyboardAwareScrollView from '@/features/popup/components/BottomSheetKeyboardAwareScrollView';
import { PostEditorModalShell } from '@/features/post-editor/components/editor/PostEditorModalShell';
import { LocationPicker } from '@/features/post-editor/components/location/LocationPicker';
import { PostForm } from '@/features/post-editor/constants/form';
import { useHomeGeoArea } from '@/features/post-editor/hooks/useHomeGeoArea';
import type { PostFormValues } from '@/features/post-editor/types/postForm';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

type Props = {
  isVisible: boolean;
  onClose: () => void;
};

/** Bottom modal for picking a custom location. */
export const PostLocationModal: FC<Props> = ({ isVisible, onClose }) => {
  const { t } = useTranslation(LocalizationNameSpace.POST_CREATION, {
    keyPrefix: 'screens.post-editor'
  });
  const { control } = useFormContext<PostFormValues>();

  const { data: homeGeoArea } = useHomeGeoArea();

  const location = useController({ control, name: 'location' });

  return (
    <PostEditorModalShell
      isVisible={isVisible}
      title={t(PostForm.LOCATION)}
      onClose={onClose}
      onBackdropPress={onClose}
      fillScrollContent={false}
      stickyHeader
      scrollComponent={BottomSheetKeyboardAwareScrollView}
    >
      <LocationPicker
        defaultPosition={location.field.value ? undefined : homeGeoArea?.center}
        selectedLocation={location.field.value}
        setSelectedLocation={location.field.onChange}
      />
    </PostEditorModalShell>
  );
};
